"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillingProductPriceTierMode = exports.BillingProductPriceScheme = exports.BillingProductType = void 0;
var BillingProductType;
(function (BillingProductType) {
    BillingProductType["PLAN"] = "plan";
    BillingProductType["CARD"] = "card";
    BillingProductType["SETUP"] = "setup";
})(BillingProductType || (exports.BillingProductType = BillingProductType = {}));
var BillingProductPriceScheme;
(function (BillingProductPriceScheme) {
    BillingProductPriceScheme["TIERED"] = "tiered";
    BillingProductPriceScheme["UNIT"] = "unit";
})(BillingProductPriceScheme || (exports.BillingProductPriceScheme = BillingProductPriceScheme = {}));
var BillingProductPriceTierMode;
(function (BillingProductPriceTierMode) {
    BillingProductPriceTierMode["GRADUATED"] = "graduated";
    BillingProductPriceTierMode["VOLUME"] = "volume";
})(BillingProductPriceTierMode || (exports.BillingProductPriceTierMode = BillingProductPriceTierMode = {}));
